import React from 'react';
import { ListChecks, Baby, ShieldAlert } from 'lucide-react';

/**
 * Компонент для ввода дополнительных параметров калькулятора овуляции
 */
const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <ListChecks className="w-5 h-5 mr-2 text-rose-500" />
        Дополнительные параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Учет симптомов овуляции */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeSymptoms"
              checked={formData.includeSymptoms}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать симптомы овуляции для более точного расчета
            </span>
          </label>
          <p className="mt-1 ml-6 text-xs text-gray-500 dark:text-gray-400">
            Позволяет учесть базальную температуру, цервикальную слизь и результаты тестов на овуляцию
          </p>
        </div>

        {/* Цель расчета: планирование беременности или контрацепция */}
        <div className="col-span-full mt-2">
          <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Цель расчета
          </div>
          <div className="grid grid-cols-2 gap-3">
            <label 
              className={`flex items-center p-3 rounded-lg cursor-pointer transition ${
                formData.plannedPregnancy 
                  ? 'bg-rose-100 dark:bg-rose-900/30 border border-rose-300 dark:border-rose-700' 
                  : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'
              }`}
            >
              <input
                type="radio"
                name="plannedPregnancy"
                value="true"
                checked={formData.plannedPregnancy}
                onChange={() => handleInputChange({target: {name: 'plannedPregnancy', value: true}})}
                className="form-radio mr-2"
              />
              <div className="flex flex-col md:flex-row md:items-center">
                <Baby className="w-5 h-5 text-rose-500 mb-1 md:mb-0 md:mr-2 flex-shrink-0" />
                <div>
                  <span className="text-sm font-medium block text-gray-700 dark:text-gray-300">
                    Планирование беременности
                  </span>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    Определение благоприятных дней для зачатия
                  </span>
                </div>
              </div>
            </label>
            <label 
              className={`flex items-center p-3 rounded-lg cursor-pointer transition ${
                !formData.plannedPregnancy 
                  ? 'bg-rose-100 dark:bg-rose-900/30 border border-rose-300 dark:border-rose-700' 
                  : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'
              }`}
            >
              <input
                type="radio"
                name="plannedPregnancy"
                value="false"
                checked={!formData.plannedPregnancy}
                onChange={() => handleInputChange({target: {name: 'plannedPregnancy', value: false}})}
                className="form-radio mr-2"
              />
              <div className="flex flex-col md:flex-row md:items-center">
                <ShieldAlert className="w-5 h-5 text-rose-500 mb-1 md:mb-0 md:mr-2 flex-shrink-0" />
                <div>
                  <span className="text-sm font-medium block text-gray-700 dark:text-gray-300">
                    Контрацепция
                  </span>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    Определение безопасных дней
                  </span>
                </div>
              </div>
            </label>
          </div>
        </div>

        {/* Предупреждение о методе */}
        <div className="col-span-full mt-2 bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-lg border border-yellow-200 dark:border-yellow-800">
          <p className="text-sm text-yellow-700 dark:text-yellow-300 flex items-start">
            <ShieldAlert className="w-5 h-5 text-yellow-500 mr-2 flex-shrink-0 mt-0.5" />
            <span>
              <strong>Важно!</strong> Календарный метод не является 100% надежным. Для более точного определения овуляции рекомендуется использовать комбинацию методов, включая измерение базальной температуры и тесты на овуляцию. При использовании в качестве метода контрацепции, обязательно проконсультируйтесь с врачом.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;